import { FormikTextInput, FormikField } from "@betterment/style-closet-react";
import { w as withoutOutline } from "./WithoutOutline-_MwFlIvo.js";
import styled from "@emotion/styled";
const FullWidthTextInput = styled(FormikTextInput)`
  max-width: 100%;
`;
const Field = withoutOutline(FormikField);
const FullWidthField = withoutOutline(FullWidthTextInput);
export {
  FullWidthField as F,
  Field as a
};
//# sourceMappingURL=Field-DmbDMqah.js.map
